import React, { Component } from 'react';
// import PropTypes from 'prop-types';
import format from 'date-fns/format';
import distanceInWords from 'date-fns/distance_in_words';

const ReactMarkdown = require('react-markdown');

export class Post extends Component {
  render() {
    const { post } = this.props;
    const { date, body } = post;
    return (
      <div className="card" style={{ marginBottom: 10 }}>
        <div className="card-header">
          {format(date, 'YYYY-MM-DD')}{' '}
          <small>{distanceInWords(date, new Date())} ago</small>
          <button
            type="button"
            className="btn btn-outline-secondary float-right btn-sm"
          >
            edit
          </button>
        </div>
        <div className="card-body">
          <ReactMarkdown source={body} />
        </div>
      </div>
    );
  }
}

// https://reactjs.org/docs/typechecking-with-proptypes.html#proptypes
// Post.propTypes = {};

export default Post;



// WEBPACK FOOTER //
// ./src/components/Post.js